import { Fragment, useEffect } from "react";
import { useSelector } from "react-redux";
import { Field, Form, FormElement } from "@progress/kendo-react-form";
import { FormRegion } from "../../../components/formregion";
import { FormInput, FormTextArea } from "../../../forms/form-components";
import { Button } from "@progress/kendo-react-buttons";

import i18next from "i18next";
import { useTranslation } from "react-i18next";

export const UserInfoPageForm = (props) => {
  const pageState = useSelector((state) => state.accountManagementPage);
  const currentTheme = useSelector((state) => state.currentTheme);
  const updateDirtyState = props.updateDirtyState;
  const { handleOnChangeField, onUpdateUserInfo, onChangePasswordClick } =
    props;

  useEffect(() => {
    updateDirtyState();
  }, [pageState.formInitialValues, pageState.formValues]);

    const {t} = useTranslation();
  return (
    <Fragment>
      <Form
        key={pageState.formKey} // Forces re-render when state updates
        initialValues={{
          Organisation: pageState.formValues.User.Organisation,
          Name: pageState.formValues.User.Name,
          Email: pageState.formValues.User.Email,
          Description: pageState.formValues.User.Description,
        }}
        render={(formRenderProps) => (
          <FormElement horizontal={false}>
            <FormRegion>
              <div
                className="form-group accountmanagement-user-fields"
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "20px",
                  marginBottom: "50px",
                }}
              >
                <Field
                  id="Organization"
                  name="Organisation"
                  label={t("accountmang.tabs.org")}
                  component={FormInput}
                  disabled
                />
                <Field
                  id="Name"
                  name="Name"
                  label={t("accountmang.tabs.name")}
                  component={FormInput}
                  onChange={(e) => {
                    handleOnChangeField("Name", e.value);
                  }}
                />
                <Field
                  id="Email"
                  name="Email"
                  label={t("accountmang.tabs.email")}
                  component={FormInput}
                  type="email"
                  disabled
                />
                <Field
                  id="Description"
                  name="Description"
                  label={t("accountmang.tabs.description")}
                  component={FormTextArea}
                  onChange={(e) => {
                    handleOnChangeField("Description", e.value);
                  }}
                />
              </div>
              <div
                className="accountmanagement-user-actions"
                style={{ display: "flex", justifyContent: "space-between" }}
              >
                {/* <button
                  className="btn btn-primary"
                  style={{ padding: "5px 20px" }}
                  onClick={onUpdateUserInfo}
                >
                  Update Profile
                </button> */}
                <Button
                  style={{
                    padding: 8,
                    color: currentTheme.touchColor,
                    fontWeight: 500,
                  }}
                  onClick={onUpdateUserInfo}
                >
                   {t("accountmang.tabs.update")}
                </Button>
                <Button
                  style={{
                    padding: 8,
                    color: currentTheme.touchColor,
                    fontWeight: 500,
                  }}
                  onClick={onChangePasswordClick}
                >
                     {t("accountmang.tabs.change")}
                </Button> 
              </div>
            </FormRegion>
          </FormElement>
        )}
      />
    </Fragment>
  );
};
